import { toast } from "@rentiohq/shared-frontend/dist/managers/Toast";
import {
  IAlert,
  registerAlertTrigger,
} from "@rentiohq/shared-frontend/dist/utils/alert/alert.utils";
import { getMessageForError } from "@rentiohq/shared-frontend/dist/utils/error.utils";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

const alertTrigger = ({ message = "", error, type, content }: IAlert) => {
  toast({
    type,
    heading: error ? getMessageForError(error) : message,
    content,
  });
};
registerAlertTrigger(alertTrigger);

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
